export const ERR_INVALID_FILTER="Invalid filter!";
export const ERR_NO_FILTERS_SELECTED="No filters selected!";
export const ERR_NOT_IMPLEMENTED_FILTER = "doFilter not implemented!";
export const ERR_INVALID_STARTUP = "Invalid Startup Data!";
export const ERR_INVALID_INVESTOR = "Invalid Investor Data!";
